export default "__VITE_PUBLIC_ASSET__657eac02__"